import React from 'react'
import capbee from "../assets/6842a7f196a5b2b2149f793f6a3bebf0f3fa9777 (1).gif";
import capbee22 from "../assets/3939e60ff48ab243dd0431a6300e27947bf4065a.gif";

function About() {
  return (
    <div className='row m-0 p-0 align-items-center mt-5 bdgg'>
        <div className="col-12 col-md-2 ">
          <img src={capbee} alt="" className="w-100"  />

        </div>
        <div className="col-12 col-md-8 about py-4 fs-5 ">
        <h2 className="fw-bolder fs-1 text-center mb-3">About Bee Token</h2>
    <ul className="">
      <li>Purchase token “BEE” in multiples of 25 USDT, BEE is 1:1 USDT</li>
      <li>BEE token address is 0x…..</li>
      <li>
        BEE token can be used to purchase exclusive products on BEE mall. More
        information is available on www.BEEToken.com
      </li>
    </ul>
        </div>
        <div className="col-12 col-md-2">
          <img src={capbee22} alt="" className="w-100"  />

        </div>
        
    </div>
  )
}

export default About